import * as React from 'react';

import classNames from 'classnames';

import { Icon } from '@base/components/Icon';

import { IconStar } from '@icons';

import { IRatingProps } from './types';

import * as s from './Rating.scss';

export const Rating = (props: IRatingProps) => {
	const {
		className,
		rating,
		voters,
	} = props;

	return rating != null
		? <div className={classNames(s.block, className)}>
			<Icon
				className={s.icon}
				glyph={IconStar}
			/>
			<span className={s.text}>{rating}</span>
			{Boolean(Number(voters)) && <span className={s.text}>&nbsp;({voters})</span>}
		</div>
		: null;
};
